<div class="form-group mt-0">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'header.languages' | translate }} ({{ selectedLanguages.length }})</label>
            <div class="table-items">
                <div class="item item-header">
                    <div class="row">
                        <div class="col-2 align-items-center justify-content-start">{{'Enabled' | translate}}</div>
                        <div class="col-2 align-items-center justify-content-start">{{'RTL' | translate}}</div>
                        <div class="col-6 align-items-center justify-content-start"></div>
                        <div class="col-2 align-items-center justify-content-end"></div>
                    </div>
                </div>
                <div class="item" *ngFor="let lan of selectedLanguages; let last = last;">
                    <div class="row">
                        <div class="col-2 align-items-center justify-content-start">
                            <i class="fas icon-large {{lan.active ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}" (click)="lan.active = !lan.active; onChange(lan.code, lan.active)"></i>
                        </div>
                        <div class="col-2 align-items-center justify-content-start">
                            <i class="fas icon-large {{lan.rtllanguage ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}" (click)="lan.rtllanguage = !lan.rtllanguage; activateLanguageRTL(lan.code, lan.rtllanguage)"></i>
                        </div>
                        <div class="col-6 align-items-center justify-content-start">
                            {{lan.code | translate}}
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                            <confirmation [showTrashIcon]="true"
                                [question]="'confirm.areyousure'"
                                (isConfirmed)="removeLanguage($event, lan.code)"
                                *ngIf="lan.code !== 'en'"
                                style="position:relative;top:-2px;"></confirmation>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="row">
                        <div class="col-2 align-items-center justify-content-start"></div>
                        <div class="col-2 align-items-center justify-content-start"></div>
                        <div class="col-6 align-items-center justify-content-start">
                            <ng-select class="custom"
                                bindLabel="text"
                                bindValue="id"
                                [items]="languages"
                                (change)="selected($event)"></ng-select>
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                            <button class="editBtn btn-dark" (click)="addLanguage()">{{ 'Add' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
